<template><div><h1 id="umsatz-nach-zeitraum-persongruppen-umsatztypen" tabindex="-1"><a class="header-anchor" href="#umsatz-nach-zeitraum-persongruppen-umsatztypen"><span>Umsatz nach Zeitraum, Persongruppen, Umsatztypen</span></a></h1>
<p>Umsatz nach Zeitraum, Persongruppen, Umsatztypen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung wertet alle Responseereignisse aus, welche im angegebenen Zeitraum [von Datum - bis Datum] angefallen sind und den gewünschten Umsatztypen entsprechen. Die Auswertung zeigt pro Personenmerkmal, unterschieden nach Sprachen, die Umsätze und - falls ein Budget eingegeben wurde - den Erfüllungsgrad zum Budget. Werden Budgetwerte mit 0 (Null) eingegeben, wird kein Erfüllungsgrad zum Budget ausgerechnet. Das Resultat wird in der Datenbank gespeichert und kann auch später am Bildschirm gezeigt oder ausgedruckt werden.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Umsatz nach Zeitraum, Personengruppen, Umsatztypen</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Datum</dt>
<dd>Einschränkung der auszuwertenden Response-Ereignisse auf einen Datumsbereich. Leere Felder machen keine Einschränkung.</dd>
<dt>Umsatztypen</dt>
<dd>mit Kommas trennen, mit ! ausschliessen, * alles</dd>
<dt>Merkmal, Budget</dt>
<dd>pro Zeile: [Merkmalswert] mit Komma trennen [Budgetwert in Fr.]</dd>
<dt>Ausgabe</dt>
<dd>Die Resultate werden in der Datenbank gespeichert</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Dargestellt wird eine Tabelle mit Sprachgruppen als Spalten und Merkmalen als Zeilen. Darin wird der Gesamtumsatz (nach den gewählten Kriterien) notiert.</p>
<p>Bei jeder Zeile ist das Total der Zeile, das Budget (aus den Parametern) und die prozentuale Erfüllung des Budgets angegeben.</p>
<p>Bei jeder Spalte ist ein Total angegeben, das den totalen Umsatz der betrachteten Adressen ausweist.</p>
<p>+-------------- Umsatz nach Zeitraum, Adressgruppen, Umsatztypen --------------+
|19.11.1998   3 14:00; 01.11.1998-16.11.1998; spe,ppa,leg                      |</p>
<table>
<thead>
<tr>
<th>Merk           d         f         i    Andere     Total    Budget        %</th>
</tr>
</thead>
<tbody>
<tr>
<td>OHK            0         0         0         0         0         0     0.00</td>
</tr>
<tr>
<td>OHGS       46050         0         0         0     46050         0     0.00</td>
</tr>
<tr>
<td>Firm       11078         0         0         0     11078         0     0.00</td>
</tr>
<tr>
<td>KGDE         251         0         0         0       251         0     0.00</td>
</tr>
<tr>
<td>Vere           0         0         0         0         0         0     0.00</td>
</tr>
<tr>
<td>3WLa         100         0         0         0       100         0     0.00</td>
</tr>
<tr>
<td>HRG            0        30         0         0        30         0     0.00</td>
</tr>
<tr>
<td>HUM            0         0         0         0         0         0     0.00</td>
</tr>
<tr>
<td>Schu           0         0         0         0         0         0     0.00</td>
</tr>
<tr>
<td>INTE           0         0         0         0         0         0     0.00</td>
</tr>
<tr>
<td>0         0         0         0         0         0     0.00</td>
</tr>
<tr>
<td>Andere     70059     15468      2545        30     88102         0     0.00</td>
</tr>
<tr>
<td>---------------------------------------------------------------------------</td>
</tr>
<tr>
<td>Total     127538     15498      2545        30    145612         0</td>
</tr>
<tr>
<td></td>
</tr>
<tr>
<td>+------------------------------------------------------------------------------+</td>
</tr>
</tbody>
</table>
<p>Adressen mit Merkmal Firm haben mit den Umsatztypen spe, ppa und leg 11078 Franken Umsatz erreicht. Dieser Umsatz kommt vollumfänglich von Adressen mit Sprache d. Der berücksichtigte Zeitraum umfasst die erste Novemberhälfte.</p>
</div></template>


